(function () {
  if (customElements.get('alb-hero-slideshow')) return;
  class AlbHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.alb-hero__slide'));
      if (this.slides.length < 2) return;
      this.dots = Array.from(this.querySelectorAll('.alb-hero__dot'));
      this.live = this.querySelector('[data-alb-live]');
      this.prevBtn = this.querySelector('.alb-hero__nav--prev');
      this.nextBtn = this.querySelector('.alb-hero__nav--next');
      this.toggle = this.querySelector('.alb-hero__playpause');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = parseInt(this.getAttribute('data-autoplay') || '0', 10);
      this.index = 0; this.playing = false; this.paused = false;
      this.show(0);
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.stop(); this.show(this.index - 1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.stop(); this.show(this.index + 1); });
      this.dots.forEach((d, i) => d.addEventListener('click', () => { this.stop(); this.show(i); }));
      if (this.toggle) this.toggle.addEventListener('click', () => { this.playing ? this.stop() : this.start(); });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.stop(); this.show(this.index - 1); }
        if (e.key === 'ArrowRight') { this.stop(); this.show(this.index + 1); }
      });
      var x0 = null;
      this.addEventListener('touchstart', (e) => { x0 = e.changedTouches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { this.stop(); this.show(this.index + (dx < 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());
      document.addEventListener('visibilitychange', () => { document.hidden ? this.pause() : this.resume(); });
      if (this.interval > 0 && !this.reduced) this.start();
    }
    show(i) {
      var n = this.slides.length; this.index = ((i % n) + n) % n;
      this.slides.forEach((s, idx) => {
        var a = idx === this.index;
        s.classList.toggle('is-active', a);
        s.setAttribute('aria-hidden', a ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach((el) => { el.tabIndex = a ? 0 : -1; });
      });
      this.dots.forEach((d, idx) => {
        var a = idx === this.index;
        d.classList.toggle('is-active', a);
        d.setAttribute('aria-selected', a ? 'true' : 'false');
      });
      if (this.live) this.live.textContent = (this.index + 1) + ' / ' + n;
    }
    start() { if (this.interval <= 0) return; this.playing = true; this.paused = false; this.tick(); this.sync(); }
    tick() { clearTimeout(this.t); if (!this.playing || this.paused) return; this.t = setTimeout(() => { this.show(this.index + 1); this.tick(); }, this.interval); }
    stop() { this.playing = false; clearTimeout(this.t); this.sync(); }
    pause() { this.paused = true; clearTimeout(this.t); }
    resume() { if (this.playing) { this.paused = false; this.tick(); } }
    sync() {
      if (!this.toggle) return;
      this.toggle.classList.toggle('is-playing', this.playing);
      this.toggle.setAttribute('aria-pressed', this.playing ? 'true' : 'false');
      var lbl = this.playing ? this.toggle.getAttribute('data-label-pause') : this.toggle.getAttribute('data-label-play');
      if (lbl) this.toggle.setAttribute('aria-label', lbl);
    }
  }
  customElements.define('alb-hero-slideshow', AlbHeroSlideshow);
})();
